angular.module('admin.users.add', [
  'resources.AdminGroup',
  'resources.AdminUser',
	'services.formErrors',
	'security'
])

.config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('admin.users.add', {
      url: '/add',
      title: 'Users / Add new',
      views: {
        'main@': {
          template: require('./admin-add-user.tpl.html'),
          controller: 'AdminAddUserCtrl',
          resolve: {
            groups: ["AdminGroup", function (AdminGroup) {
              return AdminGroup.query().$promise;
            }]
          }
        }
      }
    });
}])

.controller('AdminAddUserCtrl',
  ["$scope", "groups", "AdminUser", "formErrors", "growl", "$location", "security", function($scope, groups, AdminUser, formErrors, growl, $location, security) {
    $scope.groups = groups.data;

    $scope.submit = function (data) {
      var toSubmit = angular.copy(data);
      toSubmit.is_active = true;

      if (toSubmit.account.groups) {
        toSubmit.account.groups = _.map(toSubmit.account.groups, '_id');
			}
			
			toSubmit.password = security.createHash(toSubmit.password);

      AdminUser.save(toSubmit, function (result) {
        growl.info('User saved!');
        $location.path('/admin/users/edit/' + result._id);
      }, formErrors.growlErrors);
    };
  }]);



// WEBPACK FOOTER //
// ./client/src/app/admin/users/admin-add-user.js